import {
  HiOutlineChartPie,
  HiOutlineClipboardList,
  HiOutlineDocumentText,
  HiOutlineKey,
  HiOutlineLightningBolt,
  HiOutlinePuzzle,
} from "react-icons/hi";
import { useSession } from "../../stores/session";

type Menu = {
  label: string;
  icon: any | null;
  href: string | null;
  name: string | null;
  child?: { label: string; name: string; href: string }[];
};

const dashboardMenu = {
  label: "Dasbor",
  name: "dashboard",
  icon: HiOutlineChartPie,
  href: "/",
};

const activationCodeMenu = {
  label: "Kode Aktivasi",
  name: "activation-code",
  icon: HiOutlineKey,
  href: "/activation-code",
};

const report = {
  label: "Laporan",
  name: "final-report",
  icon: HiOutlineDocumentText,
  href: "/final-report",
};

// const PsikologFeeMenu = {
//   label: "Psikolog Fee",
//   name: "psikolog-fee",
//   icon: HiOutlineLightningBolt,
//   href: "/psikolog-fee",
// };

const AsesmenOffline = {
  label: "Asesmen Tatap Muka",
  name: "offline-asesmen",
  icon: HiOutlineClipboardList,
  href: "#",
  child: [
    {
      label: "Permintaan Asesmen",
      name: "request",
      href: "/offline-asesmen/request",
    },
    {
      label: "Lokasi Asesmen",
      name: "setting",
      href: "/offline-asesmen/setting",
    },
  ],
};

export const useMenus = (): Menu[] => {
  const { me } = useSession();

  const baseMenus: Menu[] = [
    dashboardMenu,
    activationCodeMenu,
    report,
    // PsikologFeeMenu,
  ];

  const hasOfflineAssessmentPermission = me?.permissions?.includes(
    "logos.offline-assessment"
  );

  if (hasOfflineAssessmentPermission) {
    baseMenus.push(AsesmenOffline);
  }

  return baseMenus;
};

// export const menus: Menu[] = [
//   dashboardMenu,
//   activationCodeMenu,
//   report,
//   PsikologFeeMenu,
// ];
